import { z } from "zod";
import { TReadAccess } from "../../../common/readAccess";

export type IMoveCollectionItemsMutation = z.infer<typeof TMoveCollectionItemsMutation>;
export const TMoveCollectionItemsMutation = z.object({
  itemIds: z.array(z.string()),
  folderId: z.string().optional(),
});

export type IMoveFilesMutation = z.infer<typeof TMoveFilesMutation>;
export const TMoveFilesMutation = z.object({
  fileIds: z.array(z.string()),
  folderId: z.string().optional(),
  previousFolderId: z.string().optional(),
});

export type ICreateFolderMutation = z.infer<typeof TCreateFolderMutation>;
export const TCreateFolderMutation = z.object({
  id: z.string().optional(),
  name: z.string(),
  parentFolderId: z.string().optional(),
});

export const TDuplicatePropertyCollectionFolderMutation = z.object({
  toPropertyIDs: z.array(z.string()),
  newFolderName: z.string().nullish(),
});
export type IDuplicatePropertyCollectionFolderMutation = z.infer<typeof TDuplicatePropertyCollectionFolderMutation>;

export const TDuplicatePropertyCollectionItemMutation = z.object({
  toPropertyIDs: z.array(z.string()),
  newItemName: z.string().nullish(),
});
export type IDuplicatePropertyCollectionItemMutation = z.infer<typeof TDuplicatePropertyCollectionItemMutation>;

export type ICreateCollectionItemMutation = z.infer<typeof TCreateCollectionItemMutation>;
export const TCreateCollectionItemMutation = z.object({
  id: z.string().optional(),
  name: z.string(),
  readAccess: TReadAccess.optional(),
  folderID: z.string().optional(),
});
